module.exports = __webpack_public_path__ + "img/sms.d112c94f.gif";